import React from 'react';
import { Box, useMediaQuery } from "@mui/material";
import Coursesprogress from './coursesprogres';
import Projectsprogress from './ProjectsProgress';
import Learningpathprogress from './learningpathprogres';
import Hoescoreprogress from './hoesCore';
import Completedcourses from './learningpathHoe';
import useNetworkStatus from "../../../../helper/NetworkStatus";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

const LearningPathProgressDisplay = ({ selectedOption, responseData }) => {
  const isMobile = useMediaQuery("(max-width :600px)");
  const isTablet = useMediaQuery("(min-width :601px) and (max-width :1024px)");
  const { isOnline } = useNetworkStatus();

  const cardStyle = {
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
    padding: '10px',
    minHeight : '170px',
    width : '100%',
    transition: 'all 0.3s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
    },
  };

  return (
    <div>
      {isOnline ? (
        <Box sx={{ width : '100%', margin: '0 auto', padding: '10px' }}>
          {/* Layout based on screen */}
          {isMobile || isTablet ? (
            // Mobile & Tablet View: Cards stacked vertically
            <Box display="flex" flexDirection="column" gap={3}>
              {selectedOption && (
                <Box sx={cardStyle}>
                  <Coursesprogress totalCoursesProgress={responseData.totalCoursesProgress} />
                </Box>
              )}
              {selectedOption && (
                <Box sx={cardStyle}>
                  <Projectsprogress totalProjectsProgress={responseData.totalProjectsProgress} />
                </Box>
              )}
              {selectedOption && (
                <Box sx={cardStyle}>
                  <Hoescoreprogress HOE={responseData.HOE} />
                </Box>
              )}
              {selectedOption && (
                <Box sx={cardStyle}>
                  <Learningpathprogress learningPathProgress={responseData.learningPathProgress} />
                </Box>
              )}
              {selectedOption && (
                <Box sx={{ ...cardStyle, textAlign: 'center' }}>
                  <Completedcourses HOE={responseData.HOE} />
                </Box>
              )}
            </Box>
          ) : (
            <Box display="flex" gap="32px">
              <Box
                sx={{
                  flex: '1 1 70%',
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '32px',
                }}
              >
                {selectedOption && (
                  <Box sx={cardStyle}>
                    <Coursesprogress totalCoursesProgress={responseData.totalCoursesProgress} />
                  </Box>
                )}
                {selectedOption && (
                  <Box sx={cardStyle}>
                    <Projectsprogress totalProjectsProgress={responseData.totalProjectsProgress} />
                  </Box>
                )}
                {selectedOption && (
                  <Box sx={cardStyle}>
                    <Hoescoreprogress HOE={responseData.HOE} />
                  </Box>
                )}
                {selectedOption && (
                  <Box sx={cardStyle}>
                    <Learningpathprogress learningPathProgress={responseData.learningPathProgress} />
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  flex: '1 1 30%',
                  display: 'flex',
                  alignItems: 'stretch',
                }}
              >
                <Box
                  sx={{
                    ...cardStyle,
                    height : '100%',
                    width : '100%',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  {selectedOption && (
                    <Completedcourses HOE={responseData.HOE} />
                  )}
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      ) : (
        <ShimmerSimpleGallery card imageHeight={180} row={3} col={3} gap={20} />
      )}
    </div>
  );
};

export default LearningPathProgressDisplay;
